import type { RouteRecordRaw } from 'vue-router'
import RecruitList from '@/views/middleGround/recruit/recruitList.vue'
import RecruitDetail from '@/views/middleGround/recruit/recruitDetail.vue'
import RecruitApplyList from '@/views/middleGround/recruit/recruitApplyList.vue'
import RecruitReviewedDetail from '@/views/middleGround/recruit/recruitReviewedDetail.vue'
import RecruitWillAuditApplyList from '@/views/middleGround/recruit/recruitWillAuditApplyList.vue'
import RecruitWillAuditApplyDetail from '@/views/middleGround/recruit/recruitWillAuditApplyDetail.vue'
import RecruitStat from '@/views/middleGround/recruit/recruitStat.vue'

// 招商活动
export const RecruitRoute: Array<RouteRecordRaw> = [
  {
    path: 'recruit/recruitList',
    name: 'RecruitList',
    meta: {
      title: '招商活动-项目列表' 
    },
    component: RecruitList
  },
  {
    path: 'recruit/recruitList/recruitDetail/:id',
    name: 'RecruitDetail',
    meta: {
      title: '招商活动-项目详情' 
    },
    component: RecruitDetail
  },
  {
    path: 'recruit/recruitApplyList',
    name: 'RecruitApplyList',
    meta: {
      title: '招商活动-报名列表' 
    },
    component: RecruitApplyList
  },
  {
    path: 'recruit/recruitApplyList/recruitReviewedDetail/:id',
    name: 'RecruitReviewedDetail',
    meta: {
      title: '招商活动-报名详情' 
    },
    component: RecruitReviewedDetail
  },
  {
    path: 'recruit/recruitWillAuditApplyList',
    name: 'RecruitWillAuditApplyList',
    meta: {
      title: '招商活动-待审核的报名' 
    },
    component: RecruitWillAuditApplyList
  },
  {
    path: 'recruit/recruitWillAuditApplyList/recruitWillAuditApplyDetail/:id',
    name: 'RecruitWillAuditApplyDetail',
    meta: {
      title: '招商活动-待审核的报名' 
    },
    component: RecruitWillAuditApplyDetail
  },
  {
    path: 'recruit/recruitStat',
    name: 'RecruitStat',
    meta: {
      title: '招商活动-统计' 
    },
    component: RecruitStat
  },
]

export default RecruitRoute